import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { EcomNetworkUtils } from "../ecom-base-entities/ecom-shared/ecom-networkutils.service";
import { MMOutput } from "../ecom-models/response-model";
import { EComService } from "../ecom-services/ecom-common.service";
import { SocialAuthFontEnd, SocialAuthModel, SocialKind } from "./socials.model";


@Injectable({
    providedIn: 'root'
})

export class SocialsService {
    private readonly SocialHanshakeApi: any;
    private readonly dialCodeToCountryCodes: { [key: string]: string } = {};
    public authObjectSubject = new BehaviorSubject<SocialAuthFontEnd | null>(null);
    public authObject = this.authObjectSubject.asObservable();
    constructor(private http: HttpClient) {
        this.SocialHanshakeApi = "";
    }
    async ConvertDialToCountry(dialCode: string): Promise<string | null> {
        return this.dialCodeToCountryCodes[dialCode];
    }
    // Connect BE and check auth.
    AuthSocial(model: SocialAuthFontEnd): Observable<MMOutput> {
        if(!model) return new Observable<MMOutput>();
        
        if (model.KindId === SocialKind.Facebook)
            return this.FacebookAuth(model.UserInfo);
        else if (model.KindId === SocialKind.Google) {
            return this.GoogleAuth(model.UserInfo);
        }
        return new Observable<MMOutput>();
    }

    /**
     * Check has connected or not.
     * Return full model.
     * @param model FacebookAuthModel
     * @response 200 Return listValue Of Output as @see CustomerBySocialModel 
     * @response 306 No longer used 
     * @response 400 Bad Request
     * @response 404 Data Not found 
     * @response 406 Not aceptable 
     * @response 500 Server Error 
     */

    FacebookAuth(model: SocialAuthModel): Observable<any> {
        return this.http.post(`${this.SocialHanshakeApi}${EcomNetworkUtils.SOCIAL_AUTH_FACEBOOK}`, model);
    }

    /**
     * Check has connected google or not.
     * Return full model.
     * @param model SocialAuthModel
     * @response 200 Return listValue Of Output as @see CustomerSocialModel 
     * @response 306 No longer used 
     * @response 400 Bad Request
     * @response 404 Data Not found 
     * @response 406 Not aceptable 
     * @response 500 Server Error 
     */

    GoogleAuth(model: SocialAuthModel): Observable<any> {
        return this.http.post(`${this.SocialHanshakeApi}${EcomNetworkUtils.SOCIAL_AUTH_GOOGLE}`, model);
    }
}
